import { ExtendedProperty } from 'stores/contexts';

import { Theme } from '__generated__/api';

export const hotelProductsSchema = (property: ExtendedProperty) => [
  {
    messageContent: {
      numOfProducts: 1,
      hotelProducts: [getHotelProduct(property)],
    },
    schemaName: 'allHotelProducts',
  },
];

export const multiItemProductsSchema = (property: ExtendedProperty, packageType?: string) => {
  const brandedDealType = property.offerSummary?.messages?.find(message => message.theme === Theme.BRANDED_DEAL)?.type;

  const deal = brandedDealType
    ? {
        brandedDeal: {
          displayed: true,
          selectedDeal: brandedDealType,
          availableDeals: [{ dealType: brandedDealType }],
        },
      }
    : {};

  return [
    {
      messageContent: {
        numOfProducts: 1,
        multiItemProducts: [
          {
            multiItemProductType: packageType,
            sortPosition: 1,
            productType: 'PACKAGES',
            products: [
              {
                hotelProduct: getHotelProduct(property, deal),
              },
            ],
          },
        ],
      },
      schemaName: 'allMultiItemProducts',
    },
  ];
};

const getHotelProduct = (property: ExtendedProperty, deal?: any) => {
  const { amenities, id, pinnedDetails, sponsoredListing } = property;
  const pinnedResult = Boolean(pinnedDetails?.heading);

  return {
    deal: deal ?? {},
    pinned: { pinnedResult },
    productId: parseInt(id, 10),
    productType: 'HOTELS',
    sponsored: Boolean(sponsoredListing),
    displayedAmenities: amenities ?? [],
  };
};

export const imageGalleryAlgorithmTrackingSchema = (productId: number, imageId: number, algorithmName: string) => ({
  schemaName: 'allHotelProducts',
  messageContent: {
    numOfProducts: 1,
    hotelProducts: [{ productId, imageId, imageGalleryAlgorithm: { name: algorithmName } }],
  },
});
